export default {
	New: {
		Normal: 'new-normal',
		Big: 'new-big',
		Custom: 'new-custom'
	},
	Old: {
		Blue: 'old-blue',
		White: 'old-white',
		Light: 'old-light'
	}
};
